import React, {useState} from 'react';
import {Case1} from './Steps/Case1';
import {Case2} from './Steps/Case2';
import {Case3} from './Steps/Case3';
import {Case4} from './Steps/Case4';
import {Case5} from './Steps/Case5';
import {Case6} from './Steps/Case6';
import NotFoundPage from '../NotFoundPage';
import './StepGfl.scss';

const StepGfl = ({
                     Mydata,
                     step,
                     formData,
                     setFormData,
                     handleNext,
                     handlePrevious,
                     token,
                     handleFinalSubmit
                 }) => {


    const [infoComplementaires] = useState('');

    if (!Mydata) {
        return <NotFoundPage/>;
    }

    let contentComponent;

    switch (step) {
        case 1:
            contentComponent = <Case1 onNext={handleNext} formData={formData}/>;
            break;
        case 2:
            contentComponent = (
                <Case2
                    num_societaire={Mydata.numero}
                    onNext={handleNext}
                    onPrevious={handlePrevious}
                    formData={formData}
                    setFormData={setFormData}
                />
            );
            break;
        case 3:
            contentComponent = (
                <Case3
                    onNext={handleNext}
                    onPrevious={handlePrevious}
                    token={token}
                    formData={formData}
                />
            );
            break;
        case 4:
            contentComponent = (
                <Case4
                    onNext={handleNext}
                    onPrevious={handlePrevious}
                    token={token}
                    formData={formData}
                />
            );
            break;
        case 5:
            contentComponent = (
                <Case5
                    onNext={handleNext}
                    onPrevious={handlePrevious}
                    token={token}
                    formData={formData}
                />
            );
            break;
        case 6:
            contentComponent = (
                <Case6
                    data={formData.infoComplementaires ? formData.infoComplementaires : infoComplementaires}
                    onFinalSubmit={handleFinalSubmit}
                    onPrevious={handlePrevious}
                    formData={formData}
                    setFormData={setFormData}
                    token={token}
                />
            );
            break;

        default:
            contentComponent = null;
            break;
    }

    return (
        <div className="conteneur">
            <form>
                <div className="texte">
                    {contentComponent}
                </div>
            </form>
        </div>
    );
};

export default StepGfl;